import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAllCountries } from "store/actions/citySlice";


export default function CustomPhoneInput({
  onChange,
  initialPhoneCode,
  initialPhoneNumber,
}) {
  const dispatch = useDispatch();
  const { countries } = useSelector((state) => state.Cities);

  const [selected, setSelected] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(initialPhoneNumber || "");
  const [phoneNumberLimit, setPhoneNumberLimit] = useState(null);
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  useEffect(() => {
    if (countries && countries.length > 0) {
      let foundCountry = null;
      if (initialPhoneCode) {
        foundCountry = countries.find((c) => c.dialCode === initialPhoneCode);
      }
      const defaultCountry = foundCountry || countries[0];
      setSelected(defaultCountry);

      // ✅ also set phoneNumberLimit for cookie restore
      setPhoneNumberLimit(defaultCountry?.phoneNumberLimit);

      if (onChange && defaultCountry) {
        onChange({
          phoneNumber,
          countryCode: defaultCountry.dialCode,
          phoneNumberLimit: defaultCountry.phoneNumberLimit,
        });
      }
    }
  }, [countries, initialPhoneCode]);

  const handlePhoneChange = (e) => {
    const newPhone = e.target.value;
    setPhoneNumber(newPhone);
    if (onChange && selected) {
      onChange({
        phoneNumber: newPhone,
        countryCode: selected.dialCode,
        phoneNumberLimit: selected.phoneNumberLimit,
      });
    }
  };

  const handleCountryChange = (e) => {
    const newCountry = countries.find((c) => c.dialCode === e.target.value);
    setSelected(newCountry);
    if (onChange && newCountry) {
      onChange({
        phoneNumber,
        countryCode: newCountry.dialCode,
        phoneNumberLimit: newCountry.phoneNumberLimit, // Add this
      });
    }
  };
  const [open, setOpen] = useState(false);

  const handleSelect = (country) => {
    handleCountryChange({ target: { value: country.dialCode } });
    setOpen(false);
  };

  return (
    <div className="custom_country_picker" ref={wrapperRef}>
      <div className="d-flex align-items-center gap-2">
        {/* Country select */}
        <div className="country_code_wrapper position-relative">
          {/* Selected item */}
          <div
            className=" d-flex align-items-center country_preview position-relative"
            onClick={() => setOpen(!open)}
          >
            <img
              src={`https://flagcdn.com/w80/${selected?.countryCode?.toLowerCase()}.png`}
              className="position-absolute"
              style={{ width: "20px", height: "15px" }}
            />
            <span className="ltr">{selected?.dialCode || "Select"}</span>
          </div>

          {/* Dropdown options */}
          {open && (
            <div className="country_code__options_wrapper position-absolute bg-white shadow rounded mt-1 w-100">
              {countries?.map((country) => (
                <div
                  key={country.id}
                  className="d-flex align-items-center p-2 option-item position-relative"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSelect(country)}
                >
                  <img
                    src={`https://flagcdn.com/w80/${country.countryCode.toLowerCase()}.png`}
                    alt="flag"
                    className="position-absolute"
                    style={{ width: "20px", height: "15px" }}
                  />
                  <span>{country.dialCode}</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Phone number input */}
        <input
          type="text"
          className="form-control py-2"
          placeholder="5XXXXXXX"
          value={phoneNumber}
          onChange={handlePhoneChange}
          inputMode="numeric"
          style={{ borderRadius: "10px" }}
        />
      </div>
    </div>
  );
}
